












































import {Component, ComponentConfig, ComponentStyle, ComponentStyleDefinition, Prop, Recommendation, Vue, SectionType} from "@zoovu/runner-browser-api";
import {RecommendationConfiguration} from "../configuration";
import {scrollToElement} from "./utils";

@Component({})
export default class AdviceNavigationView extends Vue {

    @Prop()
    advice: Recommendation;

    @Prop()
    sectionType: SectionType;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(RecommendationConfiguration)
    configuration: RecommendationConfiguration;

    onClickBack() {
        this.advice.navigation.previousPage();
        this.scrollToRecommendations();
    }

    onClickNext() {
        this.advice.navigation.nextPage();
        this.scrollToRecommendations();
    }

    goToPage(pageNumber: number) {
        if (pageNumber < 0) {
            pageNumber = 0;
        }

        if (pageNumber >= this.navigablePagesCount) {
            pageNumber = this.navigablePagesCount - 1;
        }

        this.advice.navigation.goToPage(pageNumber);
        this.scrollToRecommendations();
    }

    get isResultsPage(): boolean {
        if (this.sectionType) return this.sectionType === SectionType.RESULTS_PAGE;
        return false;
    }

    get currentPageIndex(): number {
        return this.advice.currentPage.pageNumber;
    }

    get startIndex(): number {
        if (this.currentPageIndex === 0 || this.currentPageIndex - Math.floor(this.visiblePagesCount / 2) <= 0) {
            return 0;
        }

        if (this.currentPageIndex === this.navigablePagesCount - 1) {
            return this.currentPageIndex - this.visiblePagesCount + 1;
        }

        if (this.currentPageIndex - Math.floor(this.visiblePagesCount / 2) + this.visiblePagesCount > this.navigablePagesCount) {
            return this.navigablePagesCount - this.visiblePagesCount;
        }

        return this.currentPageIndex - Math.floor(this.visiblePagesCount / 2);
    }

    get navigablePagesCount(): number {
        const navigablePagesCountOfCurrentSection = this.isResultsPage ? this.configuration.numberOfRecommendationPagesInResultsSection : this.configuration.numberOfRecommendationPagesInQuestionnaireSection;
        return Math.min(navigablePagesCountOfCurrentSection, this.advice.navigation.maxPages);
    }

    get visiblePagesCount(): number {
        return Math.min(3, this.navigablePagesCount);
    }

    scrollToRecommendations() {
        if (!this.$root.$refs.recommendationView) return;

        scrollToElement(this.$root.$refs.recommendationView as Element);
    }
}
